import { NavLink, Outlet } from 'react-router-dom'
import { ThemeToggle } from '@diwata/ironvale'
import { DaemonSidebar } from './DaemonSidebar'
import { SignOutButton } from './SignOutButton'

function navClass({ isActive }: { isActive: boolean }) {
  return isActive ? 'iv-nav-item iv-nav-item--active' : 'iv-nav-item'
}

export function Layout() {
  return (
    <div className="ap-shell">
      <nav className="ap-nav">
        <div className="ap-nav-brand">Apex</div>

        <div className="ap-nav-section">Operator</div>
        <div className="ap-nav-links">
          <NavLink to="/" end className={navClass}>Dashboard</NavLink>
          <NavLink to="/assay" className={navClass}>Assay</NavLink>
          <NavLink to="/conclave" className={navClass}>Conclave</NavLink>
        </div>

        <div className="ap-nav-section" style={{ marginTop: 16 }}>System</div>
        <div className="ap-nav-links">
          <NavLink to="/services" className={navClass}>Services</NavLink>
        </div>

        <div className="ap-nav-bottom">
          <ThemeToggle />
          <NavLink to="/settings" className={navClass}>Settings</NavLink>
          <SignOutButton />
        </div>
      </nav>

      <main className="ap-main">
        <Outlet />
      </main>

      <DaemonSidebar />
    </div>
  )
}
